<template>
  <!-- The new look: the same list in a card, with who, what and how paid in
       place of the client and address columns, which are this page's own. -->
  <div v-if="plate" class="obj-card obj-table">
    <div class="obj-card__head">
      <h2>Töökäsud sellel aadressil <small v-if="overview">· {{ overview.counts.events }}</small></h2>
    </div>
    <event-list :objectId="objectId" plate />
  </div>
  <event-list v-else :objectId="objectId" />
</template>

<script>
import EventList from '@/components/EventList.vue'

export default {
  components: { EventList },
  props: {
    objectId: {
      required: true
    },
    plate: {
      type: Boolean,
      default: false
    },
    overview: {
      type: Object,
      default: null
    }
  }
}
</script>
